import React, {useState, useEffect} from 'react';

import Waiting from '../StudioWaiting/Waiting';

import './StudioTimerWaiter.scss';

type StudioTimerWaiterProps = {
  loadingText: string;
};

export default function StudioTimerWaiter({loadingText}: StudioTimerWaiterProps) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prevSeconds => prevSeconds + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (totalSeconds: number) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <div className="timer-waiter">
      <Waiting className="waiter-container" diameter={100} loadingText={loadingText} />
      <p className="text">{formatTime(seconds)}</p>
    </div>
  );
}
